/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 18/01/2021
 */

import * as SessionUtils from './../../../core/session_utils.js'

const removeFiscalContactRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        id: 0
    }
}

export default removeFiscalContactRequest;